import {
  Component,
  forwardRef,
  inject,
  Input,
  input,
  InputSignal,
  OnInit,
  signal,
  WritableSignal
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ParcelAppEntityParcelWrite } from '../../../../../../../openapi';
import { ParcelsPreviewComponent } from '../parcels-preview/parcels-preview.component';
import { ParcelItemForm } from '../parcel-item.form';
import { CommonModule } from '@angular/common';
import { ParcelItemFormComponent } from '../parcel-item-form/parcel-item-form.component';

@Component({
  selector: 'app-parcels-crud',
  standalone: true,
  imports: [
    ParcelsPreviewComponent,
    CommonModule,
    ParcelItemFormComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ParcelsCrudComponent),
      multi: true
    },
    ParcelItemForm
  ],
  templateUrl: './parcels-crud.component.html'
})
export class ParcelsCrudComponent implements ControlValueAccessor, OnInit {

  public tag: InputSignal<string> = input<string>('parcels');

  @Input()
  public allowedNames: string[] = [];

  @Input()
  public detailedInformationControls = false;

  @Input()
  public isEntireParcelCoveredByPlanControl = false;

  @Input()
  public planNameControl: boolean = false;

  @Input()
  public landUseControl: boolean = false;

  @Input()
  public accessControl: boolean = false;

  @Input()
  public hideContentControl: boolean = false;

  @Input()
  public parcelIdControl: boolean = false;

  public ngOnInit(): void {
    if (this.accessControl) {
      this.parcelItemForm.createAccessControl();
    }
    if (this.landUseControl) {
      this.parcelItemForm.createLandUseControl();
    }
    if (this.detailedInformationControls) {
      this.parcelItemForm.createDetailedInformationControls();
    }
    if (this.isEntireParcelCoveredByPlanControl) {
      this.parcelItemForm.createIsEntireParcelCoveredByPlanControl();
    }
    if (this.planNameControl) {
      this.parcelItemForm.createPlanNameControl();
    }
    if (this.hideContentControl) {
      this.parcelItemForm.removeControl('content');
    }
    if (this.parcelIdControl) {
      this.parcelItemForm.createParcelIdControl();
    }
  }

  public parcelItemForm: ParcelItemForm = inject(ParcelItemForm);

  public disabled = false;

  public parcels: WritableSignal<ParcelAppEntityParcelWrite[]> = signal<ParcelAppEntityParcelWrite[]>([]);

  public showItemForm = false;
  public currentIndex: number | undefined;

  public onChange: any = () => {
  };

  public onTouch: any = () => {
  };

  writeValue(value: ParcelAppEntityParcelWrite[]): void {
    this.parcels.set(value);
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public onRemoveItem(index: number): void {
    this.parcels.update(v => v.filter((_, i) => i !== index));
    this.onChange(this.parcels());
  }

  public onCancelItemForm(): void {
    this.showItemForm = false;
    this.currentIndex = undefined;
    this.onChange(this.parcels());
  }

  public onSubmitItemForm(value: ParcelAppEntityParcelWrite): void {
    if (this.currentIndex !== undefined) {
      this.parcels.update((v: ParcelAppEntityParcelWrite[]) => {
        let items = [...v];
        if (this.currentIndex !== undefined) {
          items[this.currentIndex] = { ...value, tag: this.tag() };
        }
        return items;
      });
    } else {
      this.parcels.update(v => [...v, { ...value }]);
    }
    this.showItemForm = false;
    this.currentIndex = undefined;
    this.onChange(this.parcels());
  }

}
